import { Stack } from "@fluentui/react";
import { ChoiceGroup, Panel, PrimaryButton, TextField } from "office-ui-fabric-react";
import { ITextBox, TBFontSize } from "../../../types/Floorplan.types";

export interface ITextEditorPanelProps {
    onChange: (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement | HTMLElement> | undefined, newValue: ITextBox) => void;
    onDismiss: () => void;
    value: ITextBox;
}

const onFocus = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const length = event.target.value.length;
    if (length) {
        event.target.setSelectionRange(length, length);
    }
};

export const TextEditorPanel = (props: ITextEditorPanelProps) => {
    return (
        <Panel isBlocking={false} isOpen={true} isLightDismiss={true} onDismiss={props.onDismiss} onRenderFooter={(panelProps) => (
            <Stack horizontal horizontalAlign="end" style={{padding: "0 20px"}}>
                <PrimaryButton iconProps={{iconName: "Cancel"}} onClick={props.onDismiss}>Close</PrimaryButton>
            </Stack>
        )}>
            <TextField autoFocus multiline={true} value={props.value ? props.value.text : undefined} onChange={(e, newText) => {
                let newValue = {...props.value};
                newValue.text = newText;
                props.onChange(e, newValue);
            }} onFocus={onFocus} />
            <ChoiceGroup 
                label="Font Size" 
                onChange={(e, option) => {
                    let newValue = {...props.value};
                    newValue.fontSize = option ? option.key as TBFontSize : TBFontSize.large;
                    props.onChange(e, newValue);
                }}
                options={[
                    {
                        key: "small", iconProps: {iconName: "FontDecrease"}, text: "Small"
                    },
                    {
                        key: "large", iconProps: {iconName: "FontIncrease"}, text: "Large"
                    },
                ]}
                selectedKey={props.value.fontSize}
            />
        </Panel>
    );
}